import React, { useContext } from 'react';
import { LanguageContext } from '../Context/LanguageContext';

const brands = [
  {
    name: { en: 'Shaghaf', ar: 'شغف' },
    description: {
      en: 'Shagaf is an educational platform focused on interactive learning.',
      ar: 'شغف هي منصة تعليمية تركز على التعلم التفاعلي.',
    },
    image: {
      en: '/assets/images/shagaf-en.png',
      ar: '/assets/images/shagaf-ar.png',
    },
    link: 'https://shagaf.com',
    color: '#000000',
    backgroundColor: '#ffffff',
    bg_btn: 'rgb(243, 41, 38)',
    btn_color: '#ffffff',
  },
  {
    name: { en: 'Afkar', ar: 'أفكار' },
    description: {
      en: 'Afkar is a creative space for idea incubation and tech innovation.',
      ar: 'أفكار هي مساحة إبداعية لاحتضان الأفكار والابتكار التكنولوجي.',
    },
    image: {
      en: '/assets/images/afkar-en.png',
      ar: '/assets/images/afkar-ar.png',
    },
    link: 'https://afkar.com',
    color: '#ffffff',
    backgroundColor: 'rgb(30, 34, 34)',
    bg_btn: '#ffffff',
    btn_color: 'rgb(30, 34, 34)',
  },
  {
    name: { en: 'Miras', ar: 'مِراس' },
    description: {
      en: 'Miras preserves cultural heritage through modern digital experiences.',
      ar:  'مِراس تحفظ التراث الثقافي عبر تجارب رقمية مُحدثة.',
    },
    image: {
      en: '/assets/images/miras-en.png',
      ar: '/assets/images/miras-ar.png',
    },
    link: 'https://miras.com',
    color: '#ffffff',
    backgroundColor: 'rgb(5, 29, 34)',
    bg_btn: 'rgb(226, 162, 65)',
    btn_color: '#ffffff',
  },
];

function Brands() {
  const { language } = useContext(LanguageContext);

  return (
    <div className="container-fluid brands-section py-5" id="brands" dir={language === 'ar' ? 'rtl' : 'ltr'}>
      <div className="container p-3 py-5">
        <h2 className="text-center fw-bold text-secondary text-shadow">
          {language === 'ar' ? 'علاماتنا التجارية' : 'Brands'}
        </h2>
        <p className="text-center mb-5 text-secondary">
          {language === 'ar'
            ? 'نفخر بالعمل مع هذه العلامات لتقديم أفضل الخدمات لعملائنا.'
            : 'We are proud to work with these brands to provide the best services to our clients.'}
        </p>
        <div className="row d-flex justify-content-center gap-3">
          {brands.map((brand, index) => (
            <div key={index} className="col-md-6 col-lg-3 mb-4" style={{ minHeight: '300px' }}>
              <div
                className="brand-card rounded-5 overflow-hidden shadow-sm h-100 d-flex flex-column"
                style={{
                  backgroundColor: brand.backgroundColor,
                  color: brand.color,
                  transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-5px)';
                  e.currentTarget.style.boxShadow = '0 10px 25px rgba(0,0,0,0.15)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'none';
                  e.currentTarget.style.boxShadow = '0 4px 10px rgba(0,0,0,0.05)';
                }}
              >
                <div
                  style={{
                    height: '180px',
                    overflow: 'hidden',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <img
                    src={brand.image[language]}
                    alt={brand.name[language]}
                    className="img-fluid w-100 h-100 object-fit-contain p-3"
                  />
                </div>
                <div className="p-3 d-flex flex-column justify-content-between flex-grow-1">
                  <h5 className="card-title mb-2">{brand.name[language]}</h5>
                  <p className="card-text mb-3" style={{ fontSize: '0.95rem' }}>
                    {brand.description[language]}
                  </p>
                  <a
                    href={brand.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn mt-auto"
                    style={{
                      backgroundColor: brand.bg_btn,
                      color: brand.btn_color,
                    }}
                  >
                    {language === 'ar' ? 'اعرف المزيد' : 'Learn More'}
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Brands;
